<template>
  <div>
    <md-button class="md-success" @click="showDialogDatePicker = true">
      {{ local_page_keys.btn_label_new_multiple_dates_coef }}
    </md-button>
    <v-app id="inspire">
      <v-row class="fill-height">
        <v-col>
          <v-sheet height="64">
            <v-toolbar flat color="white">
              <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                {{ local_page_keys.btn_label_today}}
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small>mdi-chevron-right</v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      outlined
                      color="grey darken-2"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>{{ local_page_keys.btn_label_month }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="600">
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="events"
                :event-color="getEventColor"
                :type="type"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:date="viewDay"
            ></v-calendar>
          </v-sheet>
        </v-col>
        <md-dialog
            class="tm-check-dialog"
            :md-active.sync="showDialog"
            :md-closed="true"
            :md-clicked-outside="true"
            :md-close-on-esc="true">
          <div class="uk-padding uk-position-relative tm-modal-page">
            <a href="#" class="uk-position-top-right tm-dialog-close" @click="closeDate">
              <span class="material-icons">close</span>
            </a>
            <md-dialog-title>
              {{ selectedDate.date }}
            </md-dialog-title>
            <md-dialog-content>
              <template v-if="selectedDate.showListTemplate">
                <md-list>
                  <template v-if="!deletedCoeff">
                    <md-list-item  v-for="event of selectedDate.events" :key="event.id">
                      {{ local_page_keys.lable_date_coeff_before_update}} {{ afterUpdatedCoef === '' ? event.name : afterUpdatedCoef }}
                      <md-button v-if="isFuture(selectedDate.date)"
                                 @click="wantToDelete(event.id, selectedDate.date)"
                                 class="md-danger"><md-icon>delete</md-icon></md-button>
                    </md-list-item>
                  </template>
                  <md-field v-if="isFuture(selectedDate.date)" :mdClearable="true">
                    <label :for="'updateCoefInput'+ selectedDate.date">{{ deletedCoeff ? local_page_keys.lable_date_coeff_create : local_page_keys.lable_date_coeff_update }}</label>
                    <md-input type="number" step="0.1" v-model="updatedCoef" :ref="'updateCoefInput'+ selectedDate.date"
                              min="0.1"
                              :name="'updateCoefInput'+ selectedDate.date" :id="'updateCoefInput'+ selectedDate.date"
                    ></md-input>
                  </md-field>
                </md-list>
              </template>
              <template v-else-if="isFuture(selectedDate.date)">
                <md-list v-if="afterUpdatedCoef !== ''">
                  <md-list-item>
                    {{ local_page_keys.lable_date_coeff_before_update }} {{ afterUpdatedCoef }}
                  </md-list-item>
                </md-list>
                <md-field :mdClearable="true">
                  <label :for="'updateCoefInput'+ selectedDate.date">{{ afterUpdatedCoef === '' ? local_page_keys.lable_date_coeff_create : local_page_keys.lable_date_coeff_update }}</label>
                  <md-input type="number" step="0.1" v-model="updatedCoef" :ref="'updateCoefInput'+ selectedDate.date"
                            min="0.1"
                            :name="'updateCoefInput'+ selectedDate.date" :id="'updateCoefInput'+ selectedDate.date"
                  ></md-input>
                </md-field>
              </template>
              <template v-else>
                <h3>{{ local_page_keys.title_without_coef }}</h3>
              </template>
            </md-dialog-content>
            <md-dialog-actions>
              <md-button v-if="updatedCoef !== '' && updatedCoef !== beforeUpdatedCoef && updatedCoef > 0"
                         class="md-success"
                         @click="updateCoef(selectedDate.date)"
              ><md-icon>done</md-icon></md-button>
              <md-button class="md-default" @click="closeDate"><md-icon>cancel</md-icon></md-button>
            </md-dialog-actions>
          </div>
        </md-dialog>
        <md-dialog
            class="tm-check-dialog"
            :md-active.sync="showDialogDatePicker"
            :md-closed="true"
            :md-clicked-outside="true"
            :md-close-on-esc="true">
          <div class="uk-padding uk-position-relative tm-modal-page">
            <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialogDatePicker = false">
              <span class="material-icons">close</span>
            </a>
            <md-dialog-content>
              <MultipleDatesHolidaysCraete
                  :local_page_keys="local_page_keys"
                  @reload="getEvebtsList" @closeWindow="showDialogDatePicker = false"></MultipleDatesHolidaysCraete>
            </md-dialog-content>
          </div>
        </md-dialog>
      </v-row>
    </v-app>
  </div>

</template>

<script>
import MultipleDatesHolidaysCraete from "../pages/Dashboard/Components/MultipleDatesHolidaysCraete.vue";

export default {
  name: "AdminCalendarComponent",
  components: {MultipleDatesHolidaysCraete},
  props: {
    local_page_keys : {
      type: Object,
      require: true
    }
  },
  data: () => ({
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    showDialog: false,
    selectedDate: {},
    events: [],
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
    wantUpdate: false,
    updatedCoef: '',
    beforeUpdatedCoef: '',
    afterUpdatedCoef: '',
    deletedCoeff: false,
    showDialogDatePicker: false,
    allowedDates: []
  }),
  methods: {
    viewDay({date}) {
      this.selectedDate['date'] = date;
      let dateEvents = [];
      for (let event of this.events) {
        if (event.date === date) {
          dateEvents.push(event)
          this.updatedCoef = event.name;
          this.beforeUpdatedCoef = event.name;
        }
      }
      this.selectedDate['events'] = dateEvents;
      this.selectedDate['showListTemplate'] = dateEvents.length > 0;
      this.showDialog = true;
    },
    getEventColor(event) {
      return event.color
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    showEvent({event}) {
      let date = event.date;
      this.viewDay({date})
    },
    getColor(coefficient) {
      let color = 'grey darken-1';
      if (coefficient < 0.5) {
        color = 'deep-purple';
      }else if (coefficient >= 0.5 && coefficient < 1) {
        color = 'indigo';
      } else if (coefficient >= 1 && coefficient < 2) {
        color = 'orange';
      } else if (coefficient >= 2) {
        color = 'green';
      }
      return color;
    },
    formatedEventsList(list) {
      let events = [];
      for (let item of list) {
        this.allowedDates.push(item.holy_date)
        events.push({
          id: item.id,
          date: item.holy_date,
          title: item.coefficient.toString(),
          name: item.coefficient.toString(),
          color: this.getColor(item.coefficient),
          start: Date.parse(item.holy_date + ' 00:00'),
          end: Date.parse(item.holy_date + ' 23:59'),
          timed: false,
        })
        this.events = events;
      }
    },
    async updateCoef(selectedEvent) {
      let row =
          [{
            coeff: this.updatedCoef,
            date: selectedEvent
          }]
      await this.$store.dispatch('holidaySettings/createdHolidays', {row});
      let data = await this.$store.getters['holidaySettings/createdHolidays'];
      if (Object.keys(data).includes('Status') && data.Status === "Ok") {
        await this.getEvebtsList();
        this.afterUpdatedCoef = this.updatedCoef;
      } else {
        this.closeDate();
        alert(this.local_page_keys.error_update)
      }
    },
    closeDate() {
      this.deletedCoeff = false;
      this.showDialog = false;
      this.selectedDate = {};
      this.updatedCoef = '';
      this.afterUpdatedCoef = '';
    },
    isFuture(date) {
      let currdate = Date.parse(date);
      let today = new Date().getTime();
      return today < currdate;
    },
    async getEvebtsList() {
      await this.$store.dispatch('holidaySettings/holidaysList');
      let data = await this.$store.getters['holidaySettings/holidaysList'];
      if (Object.keys(data).includes('list')) {
        this.formatedEventsList(data.list)
      } else {
        this.events = [];
      }
    },
    async wantToDelete(id, date) {
      if (confirm(this.local_page_keys.confirm_for_delete + date)) {
        await this.$store.dispatch('holidaySettings/deletedHoliday', id);
        let data = await this.$store.getters['holidaySettings/deletedHoliday'];
        if (Object.keys(data).includes('Status') && data.Status === "Ok") {
          await this.getEvebtsList();
          this.deletedCoeff = true;
          this.updatedCoef = '';
        } else {
          this.closeDate();
          alert(this.local_page_keys.error_update)
        }
      }
    },
  },
  async mounted() {
   await this.getEvebtsList();
    this.$refs.calendar.checkChange();

  }
}
</script>

<style scoped lang="scss">
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}
</style>